/**
 * @file Miscellaneous helper functions.
 *
 * Please find an appropriate subdirectory and avoid adding new functions to this file.
 */

/**
 * Joins the given class names together, filtering out any falsy values.
 *
 * @param classes - The class names to join together.
 * @returns The concatenated class names.
 *
 * @example
 * cn("class1", "class2", undefined, "class3"); // "class1 class2 class3"
 */
export function combineClasses(...classes: (string | undefined | null)[]) {
  return classes.filter(Boolean).join(" ");
}

/**
 * Creates a promise that will reject if the original promise doesn't resolve within the specified timeout.
 * @param promise The promise to wrap with a timeout
 * @param timeoutMs The timeout in milliseconds
 * @returns A promise that will either resolve with the original promise's value or reject with a timeout error
 */
export function createTimeoutPromise<T>(promise: Promise<T>, timeoutMs: number): Promise<T> {
  if (timeoutMs <= 0) {
    return Promise.reject(new Error("Request timed out"));
  }

  return Promise.race([
    promise,
    new Promise<T>((_, reject) =>
      setTimeout(() => reject(new Error("Request timed out")), timeoutMs)
    )
  ]);
}
